import React, { useEffect } from "react";
import "./App.css";
import Login from "./components/Common/Login";
import ForgetPassword from "./components/Common/ForgetFlow/ForgetPassword";
import MainRoutes from "./components/MainRoutes";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import OtpConfirmation from "./components/Common/ForgetFlow/OtpConfirmation";
import ResetPassword from "./components/Common/ForgetFlow/ResetPassword";
import { UserProvider } from "./components/Layout/UserContext";
import UserStoreSelect from "./components/CanteenUsers/UserStoreSelect";
import { Toaster } from "react-hot-toast";
import Scanner from "./components/CanteenUsers/Scanner";
import Menus from "./components/CanteenUsers/Menus";
import CartOrders from "./components/CanteenUsers/CartOrders";
import LoginCanteenUser from "./components/CanteenUsers/LoginPassword/LoginCanteenUser";
import OtpCanteen from "./components/CanteenUsers/LoginPassword/OtpCanteen";
import AllOrders from "./components/CanteenUsers/AllOrders";

function App() {
  const userType = localStorage.getItem("userType");

  useEffect(() => {
    const setBranding = () => {
      const defaultTitle = "HEADQUATER PRO CMS";
      const defaultFavicon = "/favicon.ico";

      const storeName = localStorage.getItem("storeName");
      const userlogo = localStorage.getItem("userlogo");

      if (storeName) {
      document.title = (storeName && storeName !== "undefined") ? storeName : defaultTitle;
      }

      if (userlogo) {
        const favicon = document.getElementById("favicon");
        if (favicon) {
          favicon.href = userlogo || defaultFavicon;
        }
      }
    };
    // Run once on mount
    setBranding();
    // Listen for custom storage update event
    window.addEventListener("storageUpdate", setBranding);
    // Cleanup
    return () => {
      window.removeEventListener("storageUpdate", setBranding);
    };
  }, []);

  return (
    <div style={{ userSelect: "none" }}>
      <Toaster
        position="top-right"
        reverseOrder={false}
        containerClassName="custom-toast-container"
      />
      <UserProvider>
        <BrowserRouter>
          <Routes>
            {/* Login Routes */}

            <Route path="/staff" element={<Login role="staff" />} />
            <Route path="/vendor" element={<Login role="vendor" />} />
            <Route path="/canteenUser" element={<Login role="canteenUser" />} />
            <Route path="/canteen_UserLogin" element={<LoginCanteenUser />} />
            <Route path="/otpCanteen" element={<OtpCanteen />} />

            {/* user caneen flow */}
            <Route path="/menuScanner" element={<UserStoreSelect />} />
            <Route path="/scanner/:id" element={<Scanner />} />
            <Route path="/menus/:id" element={<Menus />} />
            <Route path="/cartOrders" element={<CartOrders />} />
            <Route path="/allOrders" element={<AllOrders />} />
            {/* Forget Password Flow */}
            <Route path="/forgetPassword/:role" element={<ForgetPassword />} />
            <Route path="/otpConfirmation" element={<OtpConfirmation />} />
            <Route path="/resetPassword" element={<ResetPassword />} />

            {/* Main Dashboard */}
            <Route path="/mainDashboard/*" element={<MainRoutes />} />

            {/* Default Route  Login */}
            <Route
              path="/"
              element={
                userType === "vendor" ? (
                  <Navigate to="/vendor" />
                ) : userType === "staff" ? (
                  <Navigate to="/staff" />
                ) : userType === "canteenUser" ? (
                  <Navigate to="/canteenUser" />
                ) : (
                  <Navigate to="/vendor" />
                )
              }
            />
          </Routes>
        </BrowserRouter>
      </UserProvider>
    </div>
  );
}

export default App;
